const VariantImages = {
  // Global
  AnalyticIcon: require('./img/variants/emt/analytic-icon.png'),
  CheckValidIcon: require('./img/variants/emt/check-valid-icon.png'),
  EMT: require('./img/variants/emt/emt.png'),
  EmtSelect: require('./img/variants/emt/select-emt.png'),
  SSSelect: require('./img/variants/emt/select-ss.png'),

  // Icons
  AlertIcon: require('./img/variants/emt/icons/alert.svg'),

  // Home
  HomePremium: require('./img/variants/emt/home/home-premium.png'),
  HomeSafety: require('./img/variants/emt/home/home-safety.svg'),
  HomeGoodConduct: require('./img/variants/emt/home/home-good-conduct.png'),
  HomeMessagesTips: require('./img/variants/emt/home/home-messages-tips.png'),
  HomeProfileTips: require('./img/variants/emt/home/home-profile-tips.png'),
  HomeSafetyPurple: require('./img/variants/emt/home/home-safety-purple.svg'),
  HomeGoodConductPurple: require('./img/variants/emt/home/home-good-conduct-purple.svg'),
  HomeMessagesTipsPurple: require('./img/variants/emt/home/home-messages-tips-purple.svg'),
  HomeProfileTipsPurple: require('./img/variants/emt/home/home-profile-tips-purple.svg'),
  HomeDogForm: require('./img/variants/emt/home/home-dog-form.png'),
  HomeDogLeash: require('./img/variants/emt/home/home-dog-leash.png'),
  // Premium
  PremiumMessageImg: require('./img/variants/emt/premium/premium-messages-mobile.png'),
  InfoMeetBeforeImg: require('./img/variants/emt/premium/information-meet-before.svg'),
  InfoReviewStarImg: require('./img/variants/emt/premium/information-review-star.svg'),
  InfoPetSitterExpertImg: require('./img/variants/emt/premium/information-petsitter-expert.svg'),
  InfoAssistanceImg: require('./img/variants/emt/premium/information-assistance.png'),
  InfoProfileImg: require('./img/variants/emt/premium/information-profile.svg'),
  InfoLoveImg: require('./img/variants/emt/premium/information-love.svg'),
  FraisGreen: require('./img/variants/emt/premium/frais-green.svg'),
  InfoInsuranceImg: require('./img/variants/emt/premium/information-insurance.png'),
  InfoSitterImg: require('./img/variants/emt/premium/information-sitter.svg'),
  InfoMessagesImg: require('./img/variants/emt/premium/information-messages.png'),
  InfoVeterinaryImg: require('./img/variants/emt/premium/information-veterinary-insurance.png'),
  InfoPhoneImg: require('./img/variants/emt/premium/information-phone.png'),
  InfoGiftImg: require('./img/variants/emt/premium/gift.svg'),
  PremiumLandingImg: require('./img/variants/emt/premium/premium-landing.png'),
  PremiumLandingPurpleImg: require('./img/variants/emt/premium/premium-landing-purple.svg'),
  PremiumUserQuote: require('./img/variants/emt/premium/user-quote.png'),
  PremiumUserQuotePurple: require('./img/variants/emt/premium/user-quote-purple.svg'),
  PremiumPaymentImg: require('./img/variants/emt/premium/premium-paiement-illustration.png'),
  PremiumTrustPilot: require('./img/variants/emt/premium/premiumtrustpilot.svg'),
  Premium30MillionsAmis: require('./img/variants/emt/premium/premium30millionsamis.svg'),
  PremiumHandiChiens: require('./img/variants/emt/premium/premiumhandichiens.svg'),
  Valid: require('./img/variants/emt/premium/valid.svg'),
  Invalid: require('./img/variants/emt/premium/invalid.svg'),
  ContactBenevoles: require('./img/variants/emt/premium/contactbenevoles.svg'),
  ContactPetsitters: require('./img/variants/emt/premium/contactpetsitters.svg'),
  FraisReservations: require('./img/variants/emt/premium/fraisreservations.svg'),
  GardesBenevoles: require('./img/variants/emt/premium/gardesbenevoles.svg'),
  GardesPetsitter: require('./img/variants/emt/premium/gardespetsitter.svg'),
  GarantieSatisfait: require('./img/variants/emt/premium/garantiesatisfait.svg'),
  GarantieAnnulation: require('./img/variants/emt/premium/garantieannulation.svg'),
  VerificationId: require('./img/variants/emt/premium/verificationid.svg'),
  Joignable: require('./img/variants/emt/premium/joignable.svg'),
  JoignablePurple: require('./img/variants/emt/premium/joignable-purple.svg'),

  BankCards: require('./img/variants/emt/premium/bank-card.png'),
  BankCardsMobile: require('./img/variants/emt/premium/bank-card-mobile.png'),
  ApplePay: require('./img/variants/emt/premium/apple-pay.svg'),
  ApplePayWhite: require('./img/variants/emt/premium/apple-pay-white.svg'),
  GooglePay: require('./img/variants/emt/premium/google-pay.svg'),
  GooglePayWhite: require('./img/variants/emt/premium/google-pay-white.svg'),
  Paypal: require('./img/variants/emt/premium/paypal.svg'),
  PaypalWhite: require('./img/variants/emt/premium/paypal-white.svg'),
  CreditCardIcon: require('./img/variants/emt/premium/credit-card-icon.svg'),
  CheckIcon: require('./img/variants/emt/premium/check.svg'),

  // View public profile
  DrawPassionnes: require('./img/variants/emt/view-public-profile/draw-passionnes.svg'),
  LogoCtaSign: require('./img/variants/emt/view-public-profile/logo-cta-sign.svg'),
  BackgroundCtaSign: require('./img/variants/emt/view-public-profile/background-cta-sign.jpg'),
  IconDisponibility: require('./img/variants/emt/view-public-profile/disponibility.svg'),
  IconContact: require('./img/variants/emt/view-public-profile/contact.svg'),
  IconLocalisation: require('./img/variants/emt/view-public-profile/localisation.svg'),
  IconLike: require('./img/variants/emt/view-public-profile/like.svg'),
  IconTick: require('./img/variants/emt/view-public-profile/tick.svg'),
  TrustPilot: require('./img/variants/emt/view-public-profile/trustpilot.png'),

  //Icons
  Location: require('./img/variants/emt/icons/location.svg'),
  Star: require('./img/variants/emt/icons/star.svg'),
  Close: require('./img/variants/emt/icons/close.svg'),
  ArrowsIn: require('./img/variants/emt/icons/arrowsin.svg'),
  ArrowsOut: require('./img/variants/emt/icons/arrowsout.svg'),

  // Map
  MapPinHome: require('./img/variants/emt/map/map-pin-home.png'),
  MapPin: require('./img/variants/emt/map/map-pin.png'),
  MapPinSitter: require('./img/variants/emt/map/map-pin-sitter.svg'),
  MapPinSitterActive: require('./img/variants/emt/map/map-pin-sitter-active.svg'),
  MapPinUrl: '/variants/emt/map-pin.png',
  // Contact
  PhoneImg: require('./img/variants/emt/contact/phone.png'),
  EmailImg: require('./img/variants/emt/contact/email.png'),
  ChatImg: require('./img/variants/emt/contact/chat.png'),
  MailImg: require('./img/variants/emt/contact/mail.png'),
  // ID-CHECK
  IDCardImg: require('./img/variants/emt/id-check/idcard.png'),
  IDCardImgStep2: require('./img/variants/emt/id-check/step2-idcard.png'),
  IDCardImgStep2Verso: require('./img/variants/emt/id-check/step2-idcard-verso.png'),
  IDCardImgStep2Sitter: require('./img/variants/emt/id-check/step2-idcard-sitter.svg'),
  IDCardImgStep2SitterVerso: require('./img/variants/emt/id-check/step2-idcard-sitter-verso.png'),
  FileSendedImg: require('./img/variants/emt/id-check/file-sended.png'),
  FileSendingImg: require('./img/variants/emt/id-check/file-sending.png'),
  PassportImg: require('./img/variants/emt/id-check/passport.png'),
  FooterImg: require('./img/variants/emt/id-check/footer.png'),
  FooterImgSitter: require('./img/variants/emt/id-check/footer-sitter.svg'),
  ValidateImg: require('./img/variants/emt/id-check/validate.png'),
  ValidateImgSitter: require('./img/variants/emt/id-check/validate-sitter.svg'),
  WrongPosition1Img: require('./img/variants/emt/id-check/wrong-position-1.png'),
  WrongPosition2Img: require('./img/variants/emt/id-check/wrong-position-2.png'),
  WrongPosition3Img: require('./img/variants/emt/id-check/wrong-position-3.png'),
  WrongPosition1ImgSitter: require('./img/variants/emt/id-check/wrong-position-1-sitter.svg'),
  WrongPosition2ImgSitter: require('./img/variants/emt/id-check/wrong-position-2-sitter.svg'),
  WrongPosition3ImgSitter: require('./img/variants/emt/id-check/wrong-position-3-sitter.svg'),
  // Sign-up
  SignUpBorrower: require('./img/variants/emt/sign-up/borrower.svg'),
  SignUpOwner: require('./img/variants/emt/sign-up/pet-owner.svg'),
  SignUpDogOwner: require('./img/variants/emt/sign-up/dog-owner.svg'),
  SignUpDogOwnerPurple: require('./img/variants/emt/sign-up/dog-owner-purple.svg'),
  SignUpPetSitter: require('./img/variants/emt/sign-up/pet-sitter.svg'),
  PurinaBanner: require('./img/variants/emt/sign-up/purina_banner.png'),
  PurinaBannerMobile: require('./img/variants/emt/sign-up/purina_banner_mobile.png'),
  PurinaBannerSST: require('./img/variants/emt/sign-up/purina_banner_sst.png'),
  PurinaBannerMobileSST: require('./img/variants/emt/sign-up/purina_banner_mobile_sst.png'),
  // Settings
  RenewalPremiumEndImg: require('./img/variants/emt/settings/premium.png'),
  DeleteAccountMessagesImg: require('./img/variants/emt/settings/delete-messages.png'),
  DeleteAccountProfileImg: require('./img/variants/emt/settings/delete-profil.png'),
  DeleteAccountFavoriteImg: require('./img/variants/emt/settings/delete-favorite.png'),
  DeleteAccountPremiumImg: require('./img/variants/emt/settings/delete-premium.png'),
  DeleteAccountStep3Img: require('./img/variants/emt/settings/delete-step3-illustration.png'),
  DeleteAccountStep4Img: require('./img/variants/emt/settings/delete-step4-illustration.png'),

  DisableAccountMessagesImg: require('./img/variants/emt/settings/disable-messages.png'),
  DisableAccountCommunicationImg: require('./img/variants/emt/settings/disable-communication.png'),
  DisableAccountPremiumImg: require('./img/variants/emt/settings/disable-premium.png'),
  DisableAccountProfileImg: require('./img/variants/emt/settings/disable-profile.png'),

  // Safety
  AssistanceVeterinaire: require('./img/variants/emt/safety/assistance-veterinaire.svg'),
  AssuranceCivile: require('./img/variants/emt/safety/assurance-civile.svg'),
  AssuranceDommages: require('./img/variants/emt/safety/assurance-dommages.svg'),
  AssuranceVeterinaire: require('./img/variants/emt/safety/assurance-veterinaire.svg'),
  Certification: require('./img/variants/emt/safety/certification.svg'),
  Check: require('./img/variants/emt/safety/check.svg'),
  Choix: require('./img/variants/emt/safety/choix.svg'),
  FicheToutou: require('./img/variants/emt/safety/fiche-toutou.svg'),
  LaisseObligatoire: require('./img/variants/emt/safety/laisse-obligatoire.svg'),
  PacteBonneConduite: require('./img/variants/emt/safety/pacte-bonne-conduite.svg'),
  PremiereRencontre: require('./img/variants/emt/safety/premiere-rencontre.svg'),
  Proximite: require('./img/variants/emt/safety/proximite.svg'),
  ChoixSitter: require('./img/variants/emt/sitter/safety/choix.svg'),
  FicheToutouSitter: require('./img/variants/emt/sitter/safety/fiche-toutou.svg'),
  LaisseObligatoireSitter: require('./img/variants/emt/sitter/safety/laisse-obligatoire.svg'),
  PacteBonneConduiteSitter: require('./img/variants/emt/sitter/safety/pacte-bonne-conduite.svg'),
  PremiereRencontreSitter: require('./img/variants/emt/sitter/safety/premiere-rencontre.svg'),
  ProximiteSitter: require('./img/variants/emt/sitter/safety/proximite.svg'),
  VerificationIdentite: require('./img/variants/emt/safety/verification-identite.svg'),
  Dog: require('./img/variants/emt/safety/dog.png'),
  DogSitter: require('./img/variants/emt/sitter/safety/safetydog.svg'),

  // Pet-sitter
  CheckPurple: require('./img/variants/emt/sitter/checkpurple.svg'),
  LoveMessage: require('./img/variants/emt/sitter/lovemessage.svg'),
  TestConnaissance: require('./img/variants/emt/sitter/testconnaissance.svg'),
  TestPsychologie: require('./img/variants/emt/sitter/testpsychologie.svg'),
  Quality: require('./img/variants/emt/sitter/quality.svg'),
  Annulation: require('./img/variants/emt/sitter/annulation.svg'),
  Security: require('./img/variants/emt/sitter/security.svg'),
  ActiverPremium: require('./img/variants/emt/sitter/activerpremium.svg'),
  Donateur: require('./img/variants/emt/sitter/donateur.svg'),
  CheckGreen: require('./img/variants/emt/sitter/check.svg'),
  Plant: require('./img/variants/emt/sitter/plant.svg'),
  Nosmoke: require('./img/variants/emt/sitter/nosmoke.svg'),
  SitPrice: require('./img/variants/emt/sitter/sitprice.svg'),
  SitAtHomePrice: require('./img/variants/emt/sitter/sitathomeprice.svg'),
  SitterDog: require('./img/variants/emt/sitter/sitterdog.svg'),
  SuperSittersPets: require('./img/variants/emt/sitter/super-sitters-pets.svg'),
  LogoEmtSitter: require('./img/variants/emt/sitter/logoemtsitter.svg'),
  Payments: require('./img/variants/emt/sitter/payments.svg'),
  Sent: require('./img/variants/emt/sitter/sent.svg'),
  NoRisk: require('./img/variants/emt/sitter/norisk.svg'),
  Stars: require('./img/variants/emt/sitter/stars.svg'),
  PinSitter: require('./img/variants/emt/sitter/pin.svg'),
  InValidation: require('./img/variants/emt/sitter/invalidation.svg'),
  ManageCalendar: require('./img/variants/emt/sitter/manage_calendar.svg'),
  ManageServices: require('./img/variants/emt/sitter/manage_services.svg'),
  ManageProfile: require('./img/variants/emt/sitter/manage_profile.svg'),
  HowPaid: require('./img/variants/emt/sitter/how_paid.svg'),
  HandleCalendar: require('./img/variants/emt/sitter/handle_calendar.svg'),
  CustomerService: require('./img/variants/emt/sitter/customer_service.svg'),
  WellBeing: require('./img/variants/emt/sitter/well_being.svg'),
  NoPetSitter: require('./img/variants/emt/sitter/search/no-petsitter.svg'),

  // Footer
  FooterTopLogin: require('./img/variants/emt/footerTopLogin.png'),
  FooterTopLoginSitter: require('./img/variants/emt/footerTopLoginSitter.svg'),
  FooterTopWelcomePetsitting: require('./img/variants/emt/footerTopWelcomePetsitting.svg'),
  FooterTopDesktop: require('./img/variants/emt/footerTopDesktop.png'),
  FooterTopMobile: require('./img/variants/emt/footerTopMobile.png'),
  FooterTopDesktopPurple: require('./img/variants/emt/footerTopDesktopPurple.svg'),
  FooterTopMobilePurple: require('./img/variants/emt/footerTopMobilePurple.svg'),
  FooterTopForgotPassword: require('./img/variants/emt/footerTopForgotPassword.png'),
  FooterTopResetPassword: require('./img/variants/emt/footerTopResetPassword.png'),
  FooterTopDescription: require('./img/variants/emt/create-your-profile/footerTopDescription.png'),
  FooterTopNeeds: require('./img/variants/emt/create-your-profile/footerTopNeeds.png'),
  // 404
  Footer404: require('./img/variants/emt/404/footer.png'),
  // Misc
  CrossIcon: require('./img/variants/emt/cross-icon.png'),
  AccountReactivate: require('./img/variants/emt/settings/account-reactivate.png'),
  ConnectionLink: require('./img/variants/emt/connection-link.png'),
  // Favicon
  favicon16: '/variants/emt/favicon-16x16.png',
  favicon32: '/variants/emt/favicon-32x32.png',
  favicon16SST: '/variants/emt/favicon-16x16-sst.png',
  favicon32SST: '/variants/emt/favicon-32x32-sst.png',
  // Icons
  LockIcon: require('./img/icons/lock.svg'),

  // Sitter
  Sitter: require('./img/variants/emt/sitter/sitter.svg'),
  PetSitter: require('./img/variants/emt/sitter/petsitter.svg'),

  // Welcome
  WelcomeCommunity: require('./img/variants/emt/welcome/community.svg'),
  WelcomeCommunityDog: require('./img/variants/emt/welcome/community-dog.svg'),
  WelcomeBorrower: require('./img/variants/emt/welcome/borrower.svg'),
  WelcomePetsitter: require('./img/variants/emt/welcome/petsitter.svg'),
  WelcomeReviews: require('./img/variants/emt/welcome/reviews.svg'),
  WelcomeSafety: require('./img/variants/emt/welcome/safety.svg'),
  WelcomeSafetyDog: require('./img/variants/emt/welcome/safety-dog.svg'),
  WelcomeBegin: require('./img/variants/emt/welcome/begin.svg'),

  // Missions
  Missions: require('./img/variants/emt/sitter/missions/missions.svg'),

  // NewRequest
  ReviewsNewCallRequest: require('./img/variants/emt/sitter/new-request/reviews-new-call-request.svg'),
  ReviewsCreateRequest: require('./img/variants/emt/sitter/new-request/reviews-create-request.svg'),
  IlluMap: require('./img/variants/emt/sitter/new-request/illu-map.png'),
  VetCedric: require('./img/variants/emt/sitter/new-request/vet-cedric.png'),

  // Call Request Sign Up
  AppleIcon: require('./img/variants/emt/apple-icon.svg'),
  PlayStoreIcon: require('./img/variants/emt/playstore-icon.svg'),
  TrustPilotIcon: require('./img/variants/emt/trustpilot-icon.svg'),
  Medias2: require('./img/variants/emt/medias2.svg'),
  DefaultDog: require('./img/variants/emt/create-your-profile/default-dog.png'),
  DefaultCat: require('./img/variants/emt/create-your-profile/default-cat.png'),
  DefaultNac: require('./img/variants/emt/create-your-profile/default-nac.png'),

  // Testimony
  SentTestimony: require('./img/variants/emt/testimony/sent-testimony.svg'),

  // Emergency Pet Care Relay
  EmergencyPetCareRelayHero: require('./img/variants/emt/emergency-pet-care-relay/hero.png'),
  EmergencyPetCareRelayHeroMobile: require('./img/variants/emt/emergency-pet-care-relay/hero-mobile.png'),
  EmergencyPetCareRelayLogo: require('./img/variants/emt/emergency-pet-care-relay/logo.svg'),
  EmergencyPetCareRelayBanner: require('./img/variants/emt/emergency-pet-care-relay/banner.png'),
  EmergencyPetCareRelayBannerMobile: require('./img/variants/emt/emergency-pet-care-relay/banner-mobile.png'),
  PurinaLogo: require('./img/variants/emt/emergency-pet-care-relay/purina.svg'),
  PurinaWhiteLogo: require('./img/variants/emt/emergency-pet-care-relay/purina-white.svg'),
  EmergencyPetCareRelayVideoThumbnail: require('./img/variants/emt/emergency-pet-care-relay/video-thumbnail.png'),
  EmergencyPetCareRelaySituationHealth: require('./img/variants/emt/emergency-pet-care-relay/situation-health.svg'),
  EmergencyPetCareRelaySituationMentalHealth: require('./img/variants/emt/emergency-pet-care-relay/situation-mental-health.svg'),
  EmergencyPetCareRelaySituationViolence: require('./img/variants/emt/emergency-pet-care-relay/situation-violence.svg'),
  EmergencyPetCareRelaySituationHousing: require('./img/variants/emt/emergency-pet-care-relay/situation-housing.svg'),
  EmergencyPetCareRelaySituationFamily: require('./img/variants/emt/emergency-pet-care-relay/situation-family.svg'),
  EmergencyPetCareRelaySituationOther: require('./img/variants/emt/emergency-pet-care-relay/situation-other.svg'),
}

export default VariantImages
